// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__U6wKS","active":"Navigation_active__7p+9N","bounce_nav_size":"Navigation_bounce_nav_size__hN+hw"};